let CommentFilter = Object({
    PRODUCT: {value:"product", label:"محصولات"},
    ORDER: {value:"order", label:"سفارش"},
    BRAND: {value:"brand", label:"نام تجاری"},
    CATEGORY: {value:"category", label:"دسته بندی"},
    CONTENT: {value:"content", label:"محتوا"},
    COURSE: {value:"course", label:"دوره"},
    ALL: {value:"all", label:"همه"}
});

export default CommentFilter;